import { 
    ACTUALIZAR_LIST_PROVEEDORES,
    AGREGAR_PROVEEDOR,
    MODIFICAR_PROVEEDOR,
  } from "./proveedorActions";

  const ProveedoresReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_PROVEEDORES: {
            return {
                ...state,
                proveedoresList: action.payload
            }
        };

        case AGREGAR_PROVEEDOR:{
            return {
                 ...state,
                 proveedoresList: [action.payload, ...state.proveedoresList]
             }
         };

        case MODIFICAR_PROVEEDOR: {
            return {
                ...state,
                proveedoresList: state.proveedoresList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };

        default: return state;
    }
  }

  export default ProveedoresReducer;